import React, { useEffect } from "react";
import clsx from "clsx";
import {
  ConfirmButton,
  GetUrlText,
  ServiceDialog,
  DisabledButton,
  NameTextField
} from "../../../styling/Styles"
import RequestOnApi from "./RequestOnApi";
import RecursiveProperty from "./RecursiveProperty";
import TabsParameters from "./TabsParameters";
import CreateServiceSnackBar from "../../CreateServiceSnackBar";
import DropdownMechanism from "../../GeneralComponents/DropdownMechanism";

const ServicePopUpWindow = props => {
  const {
    openAlert,
    setOpenAlert,
    responseObj,
    setResponseObj,
    editor,
    servicesBlocks,
    setServicesBlocks,
    selectedProject,
    servicesRequests,
    setServicesRequests,
    clickedEditBlockService,
    setClickedEditBlockService,
    indexEditBlockService,
    setIndexEditBlockService,
    savedPageClicked
  } = props;

  const [headers, setHeaders] = React.useState([]);
  const [params, setParams] = React.useState([]);
  const [bodyParams, setBodyParams] = React.useState([]);
  const [url, setUrl] = React.useState("");
  const [clickedSend, setClickedSend] = React.useState(false);
  const [responseStatusCode, setResponseStatusCode] = React.useState(-1);
  const [responseStatusMessage, setResponseStatusMessage] = React.useState("");
  const [selectedInputs, setSelectedInputs] = React.useState([]);
  const RequestTypes = ["GET", "PUT", "POST", "DELETE"];
  const [typeRequest, setTypeRequest] = React.useState("GET");
  const [serviceName, setServiceName] = React.useState("");
  const [openSnackBar, setOpenSnackBar] = React.useState(false);

  useEffect(() => {
    if (openAlert === true && clickedEditBlockService === true) {
      const serviceRequest =
        servicesRequests[selectedProject][indexEditBlockService];
      setTypeRequest(serviceRequest.typeRequest);
      setUrl(serviceRequest.url);
      setHeaders(serviceRequest.headers);
      setParams(serviceRequest.query_par);
      setBodyParams(serviceRequest.body_par);
      setResponseStatusCode(serviceRequest.resp_stat_cod);
      setResponseStatusMessage(serviceRequest.resp_stat_mess);
      setResponseObj(serviceRequest.response_body);
      setSelectedInputs(serviceRequest.selected_inputs);
      setServiceName(serviceRequest.name);
    } else if (openAlert === true) {
      setHeaders([]);
      setParams([]);
      setBodyParams([]);
      setUrl("");
      setClickedSend(false);
      setResponseStatusCode(-1);
      setResponseStatusMessage("");
      setSelectedInputs([]);
      setServiceName("ServiceName");
    }
  }, [openAlert]);

  const handleCancel = () => {
    setOpenAlert(false);
    setClickedEditBlockService(false);
    setIndexEditBlockService(-1);
  };

  const handleUrlInput = val => {
    setUrl(val.target.value);
  };

  const handleServiceInput = val => {
    setServiceName(val.target.value);
  };

  const handleSend = () => {
    setClickedSend(true);
  };

  const checkIfExists = indexEditBlockServ => {
    let counter = indexEditBlockServ;
    const idName = `Project${selectedProject}Block`;
    const tempServicesBlocks2 = [...servicesBlocks];
    tempServicesBlocks2[selectedProject].forEach( service => {
      if(`${idName}${counter}` === service.id){
        counter +=1;
      }
    }) 
    
    return counter;
  };

  const nameNull = () => {
    let empty = false;
    if (serviceName === "") {
      empty = true;
    }
    return empty;
  };

  const nameExists = () => {
    let exists = false;

    if (selectedProject > -1) {
      const tempServices = servicesRequests[selectedProject];
      tempServices.forEach((value, index) => {
        if (value.name === serviceName && indexEditBlockService !== index) {
          exists = true;
        }
      });
    }
    return exists;
  };

  const hasWhiteSpaces = () => {
    let exists = false;
    if (/\s/.test(serviceName)) {
      exists = true;
    }
    return exists;
  };

  const createBoxService = () => {
    if (
      nameExists() === false &&
      nameNull() === false &&
      hasWhiteSpaces() === false
    ) {
      if (clickedEditBlockService === true && editor.BlockManager !== undefined) {
        editor.BlockManager.remove(
          servicesBlocks[selectedProject][indexEditBlockService].id
        );
      }

      let insideContent = "";
      selectedInputs.forEach(val => {
        insideContent +=  `<div value-key="${val[0]}">${val[1]} </div>`;
      });



      const tempServicesBlocks = [...servicesBlocks];
      const tempServicesRequests = [...servicesRequests];

      const id = checkIfExists( (clickedEditBlockService === true) ? indexEditBlockService : tempServicesBlocks[selectedProject].length);
      const idName = `Project${selectedProject}Block${id}`;
      const blockName = `${serviceName} Block`;
      const content = `<div wablitype='service' wabli-service-id='${idName}' wabliname =${serviceName}> ${insideContent}</div>`;

      if (clickedEditBlockService === true) {
        tempServicesBlocks[selectedProject][indexEditBlockService] = {
          id: idName,
          content,
          label: blockName,
          category: "Extra "
        };
        tempServicesRequests[selectedProject][indexEditBlockService] = {
          name: serviceName,
          typeRequest,
          url,
          headers,
          query_par: params,
          body_par: bodyParams,
          resp_stat_mess: responseStatusMessage,
          resp_stat_cod: responseStatusCode,
          response_body: responseObj,
          selected_inputs: selectedInputs
        };
      } else {
        tempServicesBlocks[selectedProject].push({
          id: idName,
          content,
          label: blockName,
          category: "Extra "
        });
        tempServicesRequests[selectedProject].push({
          name: serviceName,
          typeRequest,
          url,
          headers,
          query_par: params,
          body_par: bodyParams,
          resp_stat_mess: responseStatusMessage,
          resp_stat_cod: responseStatusCode,
          response_body: responseObj,
          selected_inputs: selectedInputs
        });
      }
      setServicesBlocks(tempServicesBlocks);
      setServicesRequests(tempServicesRequests);

      const tempProjects = JSON.parse(localStorage.getItem("data"));
      tempProjects[selectedProject].services = [];
      const tempServices = {
        services_blocks: tempServicesBlocks[selectedProject],
        services_requests: tempServicesRequests[selectedProject]
      };
      tempProjects[selectedProject].services.push(tempServices);
      localStorage.setItem("data", JSON.stringify(tempProjects));

      editor.BlockManager.add(`${idName}`, {
        label: `${blockName}`,
        content,
        category: {
          label: "Extra ",
          open: "false"
        }
      });

      savedPageClicked();
      setOpenAlert(false);
      setIndexEditBlockService(-1);
      setOpenSnackBar(true);
    }
  };

  const selectTypeRequest = option => {
    setTypeRequest(option);
  };

  const returnHelperText = () =>{
    if(nameExists() === true){
      return "Service name exists";
    }
    if(nameNull() === true){
      return "Service name empty";
    }
    if(hasWhiteSpaces() === true){
      return "Spaces are not allowed";
    }
    return null;
  }


  return (
    <>
      <ServiceDialog
        open={openAlert}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
          <div style={{'maxHeight': '80vh',overflow: 'hidden'}}>
            <div className ={clsx('titlePopUp', 'paddingTitle')}>
              Create new Service
              <div onClick={handleCancel} className={clsx('pop-up-close-btn')} aria-hidden="true">x</div>
            </div>
            <div className = {clsx('paddingTitle')} style={{maxHeight: '60vh', overflow: 'auto'}}>
              <div className={clsx("flexRowDirection", "spacingTopDiv")}>
              <div className={clsx("lightBlue")}> Name: &nbsp; </div>
              <NameTextField
                id="ServiceName"
                placeholder=" Name of Service"
                onInput={e => handleServiceInput(e)}
                value={serviceName}
                error={
                  nameNull() === true ||
                  nameExists() === true ||
                  hasWhiteSpaces() === true
                }
                helperText={returnHelperText()}
              />
            </div>

            <div className={clsx("flexProps3", "spacingTop")} style={{marginBottom: "1vw"}}>

            <DropdownMechanism
              target ={typeRequest}
              targets = {RequestTypes}
              selectTarget = {selectTypeRequest}
              services = 'true'
            />


            <GetUrlText
              id="UrlText"
              value={url}
              onInput={e => handleUrlInput(e)}
              placeholder="Enter Request Url"
            >
              {" "}
              Given url
            </GetUrlText>
            <ConfirmButton onClick={handleSend}>Send</ConfirmButton>
          </div>
              <span >
                <TabsParameters
                  headers={headers}
                  setHeaders={setHeaders}
                  params={params}
                  setParams={setParams}
                  bodyParams={bodyParams}
                  setBodyParams={setBodyParams}
                />
              </span>
          
              {responseStatusCode > -1 ? (
                <div
                  style={{
                    display: "flex"
                  }}
                  className={clsx("spacingTopDiv", "spacingDownDiv")}
                >
                  Response: {responseStatusCode} {responseStatusMessage}
                </div>
              ) : null}
              {responseStatusCode > -1 ? (
                <RecursiveProperty
                  property={responseObj}
                  propertyName="Root Property"
                  excludeBottomBorder='false'
                  rootProperty='true'
                  selectedInputs={selectedInputs}
                  setSelectedInputs={setSelectedInputs}
                  parentProperty=''
                />
              ) : null}

          
          </div>
          <div
            className={clsx("flex-container", "spacingDownDiv",'paddingTitle')}
            style={{
              justifyContent: "flex-end",
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div>
              {responseStatusCode === 200  && (
                selectedInputs !== undefined && selectedInputs.length !== 0 ? (
                  <ConfirmButton onClick={createBoxService}>
                    Generate service wrapper & service block
                  </ConfirmButton>
                ) : (
                  <DisabledButton>
                    Generate service wrapper & service block
                  </DisabledButton>
                )
              )}
            </div>
          </div>
          </div>
      </ServiceDialog>
      <RequestOnApi
        setResponseObj={setResponseObj}
        url={url}
        headers={headers}
        params={params}
        bodyParams={bodyParams}
        clickedSend={clickedSend}
        setClickedSend={setClickedSend}
        setResponseStatusCode={setResponseStatusCode}
        setResponseStatusMessage={setResponseStatusMessage}
        typeRequest={typeRequest}
      />
      <CreateServiceSnackBar
        open={openSnackBar}
        setOpen={setOpenSnackBar}
        isEdit={clickedEditBlockService}
      />
    </>
  );
};

export default ServicePopUpWindow;
